import React from 'react';
import { Sun, Moon } from 'lucide-react';
import useThemeStore from '../../store/useThemeStore';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useThemeStore();
  
  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-lg bg-black dark:bg-black border border-gray-800 text-white hover:bg-primary-500 hover:text-black hover:border-primary-500 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500"
      aria-label="Toggle theme"
      title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {theme === 'dark' ? (
        <Sun size={20} />
      ) : (
        <Moon size={20} />
      )}
    </button>
  );
};

export default ThemeToggle;

